import { useEffect, useState } from "react";
import { fileService } from "../services/fileService";
import { fetchImageUrl } from "../helpers/helper";
import { S3Params } from "../components/LogoUploader";




export function ShowImage({
  s3Params,
  ...imgProps
}: {
 s3Params: S3Params;
} & React.ImgHTMLAttributes<HTMLImageElement>) {
  const [imgSrc, setImgSrc] = useState<string | null>(null);
  
  useEffect(() => {
    let objectUrl: string | null = null;
    
    async function load() {
        if(!s3Params) return;
        objectUrl = await fetchImageUrl(s3Params);
        setImgSrc(objectUrl);
    }

    load();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [s3Params]);

  if (!imgSrc && !imgProps.src) return null;

  return (
    <img
        {...imgProps}    
      src={imgSrc ?? imgProps.src}
    />
  );
}
